<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="Shield_Protected.5"
    data-name="Shield, Protected.5"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path id="Path_8549" data-name="Path 8549" d="M0,0H24V24H0Z" fill="none" />
    <path
      id="Path_8550"
      data-name="Path 8550"
      d="M8.5,9.5h7"
      transform="translate(0 0)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_8551"
      data-name="Path 8551"
      d="M8.5,13.5h7"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_8552"
      data-name="Path 8552"
      d="M20,11.242a10.345,10.345,0,0,1-7.48,9.686,1.914,1.914,0,0,1-1.04,0A10.344,10.344,0,0,1,4,11.242V7.214A2,2,0,0,1,5.243,5.363l4.864-1.99a5,5,0,0,1,3.787,0l4.864,1.99A2,2,0,0,1,20,7.214Z"
      transform="translate(0 0)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
